import { render, staticRenderFns } from "./MessageSent.vue?vue&type=template&id=aea76c6e&scoped=true"
import script from "./MessageSent.vue?vue&type=script&lang=js"
export * from "./MessageSent.vue?vue&type=script&lang=js"
import style0 from "./MessageSent.vue?vue&type=style&index=0&id=aea76c6e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aea76c6e",
  null
  
)

export default component.exports